import {
  ButtonOptionsMessage,
  ConversationLogItemMessageAdded,
  ConversationMessage,
  InlineDataConversationMessage,
  ButtonOptionsConversationMessage,
} from '@stripe-internal/conversations-client';

export const THUMBS_DOWN_ADVANCE_OPTION_ID = 'feedback_thumbs_down_advance';

function isMerchantFollowUpCaseOption(
  message: ConversationMessage | null | undefined,
) {
  // the `merchant_follow_up_case_options` inline data is used to show options for the user
  // after we show them their related support case. So, we also want to hide this inline data
  // message when the user clicks thumbs down.
  return (
    isInlineDataMessage(message) &&
    message?.inlineData?.name === 'merchant_follow_up_case_options'
  );
}

export function isInlineDataMessage(
  message: ConversationMessage | null | undefined,
) {
  return message?.type === 'inline-data-conversation-message';
}

export function isButtonOptionsMessage(
  message: ConversationMessage | null | undefined,
) {
  return message?.type === 'button-options-conversation-message';
}

export function shouldHideMessageAfterThumbsDownAdvance(
  message: ConversationMessage | undefined | null,
): message is ButtonOptionsConversationMessage | InlineDataConversationMessage {
  return (
    isMerchantFollowUpCaseOption(message) || isButtonOptionsMessage(message)
  );
}

/**
 * If an option menu is shown to user, e.g. top topics - and the user clicks thumbs down
 * we want to hide the option menu. They set this `feedback_thumbs_down_advance`
 *
 * @param item
 * @returns
 */
export function didUserSelectThumbsDownAdvanceButtonOptionsMessage(
  item: ConversationLogItemMessageAdded,
): item is ConversationLogItemMessageAdded & {
  message: ButtonOptionsMessage | InlineDataConversationMessage;
} {
  if (!shouldHideMessageAfterThumbsDownAdvance(item.message)) {
    return false;
  }
  if (isButtonOptionsMessage(item.message)) {
    return item.message.selectedOptionId === THUMBS_DOWN_ADVANCE_OPTION_ID;
  }
  if (isInlineDataMessage(item.message)) {
    return item.message.shouldHideAfterThumbsDown ?? false;
  }
  return false;
}

export function didUserSelectGetSmartSuggestionsButtonOptionsMessage(
  item: ConversationLogItemMessageAdded,
): item is ConversationLogItemMessageAdded & {
  message: ButtonOptionsMessage | InlineDataConversationMessage;
} {
  if (!shouldHideMessageAfterThumbsDownAdvance(item.message)) {
    return false;
  }
  if (isButtonOptionsMessage(item.message)) {
    return item.message.selectedOptionId === 'get-smart-suggestions';
  }
  if (isInlineDataMessage(item.message)) {
    return item.message.shouldHideAfterThumbsDown ?? false;
  }
  return false;
}
